import React, { useEffect } from 'react';
import { Modal, Form, Input, DatePicker, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import equipmentStore from '../../store/EquipmentStore';
import dayjs from 'dayjs';

const { Title } = Typography;

const EquipmentModalForm = observer(({ open, onClose, equipment = null, objectId, onSave }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      // Set form values
      form.setFieldsValue({
        name: equipment?.name || '',
        number: equipment?.number || '',
        dateExpired: equipment?.dateExpired ? dayjs(equipment.dateExpired, 'YYYY-MM-DD') : null,
        type: equipment?.type || 'оборудование',
        bitrixFolderLink: equipment?.bitrixFolderLink || '',
      });
    } else {
      form.resetFields();
    }
  }, [open, equipment, form]);

  const handleFinish = async (values) => {
    const payload = {
      name: values.name.trim(),
      number: values.number?.trim() || '',
      dateExpired: values.dateExpired ? values.dateExpired.format('YYYY-MM-DD') : null,
      type: values.type?.trim() || 'оборудование',
      bitrixFolderLink: values.bitrixFolderLink?.trim() || '',
      objectId: Number(objectId),
    };

    try {
      if (equipment?.id) {
        // Edit existing equipment
        equipmentStore.updateEquipment(equipment.id, payload);
      } else {
        // Check for duplicates
        const existingEquipment = equipmentStore.equipments.find(
          (item) =>
            item.name === payload.name &&
            item.number === payload.number &&
            item.objectId === Number(objectId)
        );

        if (existingEquipment) {
          console.warn('Оборудование с таким названием и номером уже существует');
          return;
        }

        equipmentStore.addEquipment(payload);
      }

      onSave(payload);
      onClose();
    } catch (err) {
      console.error('Ошибка при сохранении оборудования:', err);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      title={equipment ? 'Редактировать оборудование' : 'Добавить оборудование'}
      okText="Сохранить"
      cancelText="Отмена"
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={handleFinish} autoComplete="off">
        <Form.Item
          label="Название оборудования"
          name="name"
          rules={[{ required: true, message: 'Введите название оборудования' }]}
        >
          <Input maxLength={100} showCount placeholder="Например, Компрессор" />
        </Form.Item>

        <Form.Item label="Номер оборудования" name="number">
          <Input placeholder="Например, 1023-346983" />
        </Form.Item>

        <Form.Item
          label="Дата истечения"
          name="dateExpired"
          rules={[{ required: true, message: 'Укажите дату истечения' }]}
        >
          <DatePicker style={{ width: '100%' }} format="DD.MM.YYYY" />
        </Form.Item>

        <Form.Item label="Тип оборудования" name="type">
          <Input placeholder="Тип оборудования" />
        </Form.Item>

        <Form.Item label="Ссылка на папку в Битрикс" name="bitrixFolderLink">
          <Input placeholder="https://bitrix24.example.com/folder" />
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default EquipmentModalForm;
